import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseStatus } from 'src/app/shared/enums';
import Swal from 'sweetalert2';
import { BadeLoftService } from '../bade-loft.service';

@Component({
  selector: 'app-shopify-callback',
  templateUrl: './shopify-callback.component.html',
  styleUrls: ['./shopify-callback.component.css'],
})
export class ShopifyCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private _blS: BadeLoftService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    // Capture Shopify's full, unmodified callback query string (code, state, shop, hmac,
    // timestamp, host, ...). The backend validates the HMAC over this exact set, so we must
    // forward it verbatim — rebuilding from individual params drops hmac and breaks validation.
    const rawQuery = window.location.search;

    this.route.queryParams.subscribe((params) => {
      if (params) {
        var state = params['state'];

        // CSRF defense-in-depth: validate the returned state against the nonce we stored.
        const storedState = sessionStorage.getItem('shopify_oauth_state');
        if (storedState && state && state !== storedState) {
          Swal.fire({
            title: 'State mismatch',
            text: 'Possible CSRF attempt — the OAuth state did not match.',
            icon: 'error',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#326c96',
          }).then(() => {
            this._router.navigate(['/bade-loft/shopify-connection']);
          });
          return;
        }

        this.shopifyCallBack(rawQuery);
      }
    });
  }

  shopifyCallBack(queryString: string) {
    try {
      this._blS.ShopifyCallBack(queryString).subscribe((response: any) => {
        if (response && response.responseStatus == ResponseStatus.Success) {
          Swal.fire({
            title: 'Connected',
            text: 'Your connection with Shopify is successfully done!',
            icon: 'success',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#326c96',
          }).then(() => {
            this._router.navigate(['/bade-loft/shopify-connection']);
          });
        } else {
          Swal.fire({
            title: 'Failed',
            text: 'Your connection with Shopify failed!',
            icon: 'error',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#326c96',
          }).then(() => {
            this._router.navigate(['/bade-loft/shopify-connection']);
          });
        }
      });
    } catch (error) {}
  }
}
